<template>
    <label class="tiw__toggle_switch">
        <input
            :checked="modelValue"
            @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
            v-bind="$attrs"
            type="checkbox"
            class="tiw__toggle_switch__checkbox"
        />
        <span class="tiw__toggle_switch__slider"></span>
    </label>
</template>

<script lang="ts">
export default {
    name: "SwitchButton",
};
</script>

<script setup lang="ts">
const { modelValue } = defineProps<{ modelValue: boolean }>();
const emit = defineEmits<{ (e: "update:modelValue", value: boolean): void }>();
</script>

<style lang="scss" src="./switch.scss"></style>
